import React, { useState } from 'react';
import GoogleMapReact from "google-map-react";
import dhl_logo from '../../../src/assets/images/ups_logo.svg'
import { Grid } from '@material-ui/core';
import InputButton from '../../framework/Inputs/inputButton/inputButton';
import ListItem from '@material-ui/core/ListItem';
import './customGoogleMap.scss'
import List from '@material-ui/core/List';


const CustomGoogleMap = ({ data, onSelect }) => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const handleMarkerClick = (item) => {
    setSelectedMarker(item);
  };

  const handleSelect = () => {
    onSelect(selectedMarker);
  };
  const Marker = ({ item, isSelected, onClick }) => (
    <div style={{ position: 'relative', cursor: 'pointer', zIndex: isSelected ? 999 : 1 }}>
      <img src={dhl_logo} alt="dhl_logo" width="30" height="30" style={{ transition: 'transform 0.3s', transform: isSelected ? 'translateY(-10px)' : 'none' }} onClick={onClick} />
    </div>
  );
  return (
    <div style={{ position: 'relative', height: '350px' }}>
      <div style={{ height: '350px' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyAYjOCT5csZSYkhA2Try8LFEmUdRetkpa8" }}
          defaultCenter={{
            lat: data.length > 0 ? data[0].latitude : 51.505,
            lng: data.length > 0 ? data[0].longitude : -0.09,
          }}
          defaultZoom={13}
          options={{
            gestureHandling: "greedy"
        }}>
          {data.map((item, index) => (
            <Marker
              key={index}
              lat={item.latitude}
              lng={item.longitude}
              onClick={() => handleMarkerClick(item)}
            />
          ))}
        </GoogleMapReact>
      </div>

      {selectedMarker && (
        <>
          <div className="CustomGoogleMap">
            <List>
              <ListItem className="row" button >
                <div className="list-items">
                  <div className="item-one items">
                    <h2>Address:</h2>
                    <p>{selectedMarker?.title}</p>
                    <p>{selectedMarker?.address?.address1}</p>
                    <p>{selectedMarker?.address?.address2}</p>
                    <p>{selectedMarker?.address?.address3}</p>
                    <p>{selectedMarker?.address?.postalTown}</p>
                    <p>{selectedMarker?.address?.zipcode}</p>
                  </div>
                  <div className="item-two items">
                    <h2>Distance:</h2>
                    <p>Distance {parseFloat((selectedMarker?.distance || 0) * (0.00062137)).toFixed(2)} miles</p>
                  </div>
                  <div className="item-three items">
                    <h2>Opening Hours:</h2>
                    {selectedMarker?.openingHours?.map((openingTime) => (
                      <p>
                        {openingTime?.dayDescription}-{openingTime?.timeDescription}{' '}
                      </p>
                    ))}
                  </div>
                </div>
              </ListItem>
            </List>
          </div>
          <Grid item style={{ lineHeight: '20.4px', paddingBottom: '10px' }}>
            <InputButton
              id="selectService"
              variant="contained"
              className="contained-btn"
              onClick={handleSelect}
              label="Select Service Point"
            />
          </Grid>
        </>

      )}

    </div>

  );
};
export default CustomGoogleMap;